import { render } from "./ProjectTreeIndicatorArrow.vue?vue&type=template&id=386eaee6"
import script from "./ProjectTreeIndicatorArrow.vue?vue&type=script&lang=js"
export * from "./ProjectTreeIndicatorArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__